import styled from '@tanium/react-emotion-9';
import { Link } from '@tanium/react-theme-definition';
import { css } from '@tanium/style-system';

import { ClickableHoverBackground, ClickableHoverBorder, ClickableHoverShadow } from './themeDefinitions';

// based on
// https://git.corp.tanium.com/tanium/interact/blob/78f0a1a58b01f3dc0cb78a475b4983a9311b066d/src/workbench/src/pages/TaniumHome/components/Modules.tsx#L24-L36
export const ClickableLegendItem = styled('button', { shouldForwardProp: (p) => p !== 'usingMouse' })<{
  usingMouse: boolean;
}>(({ usingMouse }) =>
  css({
    background: 'transparent',
    borderRadius: 1,
    textAlign: 'left',
    boxShadow: '0 2px 0px 0 transparent',
    transition: 'border-color .1s, box-shadow .3s, background .1s',
    cursor: 'pointer',
    color: Link,
    [(usingMouse ? ':hover' : ':hover, :focus') as string]: {
      background: ClickableHoverBackground,
      borderColor: ClickableHoverBorder,
      boxShadow: ClickableHoverShadow,
    },
    ...(usingMouse && { ':focus': { outline: 'none' } }),
  }),
);
